import { Component, OnInit } from '@angular/core';

import { TextFieldComponent } from './text-field.component';
import {AbstractControl, ValidatorFn, Validators} from '@angular/forms';

@Component({
  selector: 'app-number-field-component',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss']
})
export class NumberFieldComponent extends TextFieldComponent implements OnInit {

  integer: boolean;
  positive: boolean;
  max: number;
  min: number;
  validValues: Array<number>;

  ngOnInit() {
    if (this.integer == null) { this.integer = (this.field.integer === true) }
    if (this.positive == null) { this.positive = (this.field.positive === true) }
    this.max = this.field.max;
    this.min = this.field.min;
    this.validValues = this.field.validValues;
    let sign_pattern = this.positive ? '' : "\\-?"
    let decimal_pattern = this.integer ? '' : "(\\.\\d+)?"
    this.pattern = sign_pattern + "\\d*" + decimal_pattern
    super.ngOnInit();
    this.maxLength = null;
    this.minLength = null;
    this.control.clearValidators();
    this.control.setValidators(this.loadValidators());
  }

  compare(other): number {
    let a = +this.value;
    let b = +other.value;
    if (isNaN(a)) {
      return 1;
    } else if (isNaN(b)) {
      return -1;
    } else if (a > b) {
      return 1;
    } else if (b > a) {
      return -1;
    } else {
      return 0;
    }
  }

  loadValidators() {
      let validators = [];
      if (this.required === true) {validators.push(Validators.required)}
      if (this.max != null) {validators.push(Validators.max(this.max))}
      if (this.min != null) {validators.push(Validators.min(this.min))}
      if (this.validValues != null) {validators.push(this.validateValuesFromSet(this.validValues))}
      if (this.pattern != null) {validators.push(Validators.pattern(this.pattern))}
      return validators;
  }

  validateValuesFromSet(validValues: Array<number>): ValidatorFn {
    return  (control: AbstractControl): {[key: string]: any} | null => {
      let isValid = true;
      if (control.value != null && control.value != '') {
        isValid = (validValues.find((v) => v == +control.value) != null)
      }
      return isValid ? null : {'isValid': {value: control.value}};
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/number-field.component.ts